module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/DrainTheOceans_NetEffects.c177146.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/DrainTheOceans_NetEffects.jpg
// module id = p48B
// module chunks = 0